import axios from "axios"
const addToCart = (obj) => {
    const { quantity, ringSize, sku } = obj
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    const alreadyExists = cartItems.find(item => (item.sku == sku && item.ringSize == ringSize))
    if (alreadyExists) {
        const indexOfItem = cartItems.indexOf(alreadyExists)
        cartItems.splice(indexOfItem, 1, { sku, quantity, ringSize })
        alert("Item Updated in Cart")
    } else {
        cartItems.push({ sku, quantity, ringSize })
        alert("Item Add to Cart")
    }
    localStorage.setItem('cart', JSON.stringify(cartItems))
    return cartItems
}

const productInCart = (sku) => {
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    const alreadyExists = cartItems.find(item => (item.sku == sku))
    return alreadyExists
}

const removeCartItem = (sku) => {
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    const alreadyExists = cartItems.find(item => item.sku == sku)
    const indexOfItem = cartItems.indexOf(alreadyExists)
    cartItems.splice(indexOfItem, 1)
    localStorage.setItem('cart', JSON.stringify(cartItems))
    return cartItems
}

const getCartItems = () => new Promise((resolve, reject) => {
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    if (cartItems.length == 0) {
        resolve([])
        return
    }
    const itemSkus = cartItems.map(item => item.sku)
    axios.post('/api/products', {
        // axios.post('/api/products', {
        // CategoryIds: categories,
        // page,
        // pageSize,
        SKU: itemSkus,
        Include: ["webCategories", "Media"],
        Filter: ["Orderable", "OnPriceList", "InStock"]
    }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Accept': 'application/json',
        }
    }).then(response => {
        console.log('response', response)
        const products = response.data.data.Products
        const cartObj = cartItems.map((item) => {
            for (let index = 0; index < products.length; index++) {
                const element = products[index];
                if (element.SKU == item.sku) {
                    return {
                        ...element,
                        quantity: item.quantity,
                        ringSize: item.ringSize
                    }
                }
            }
        })
        resolve(cartObj);
    }).catch(error => {
        reject(error)
    });
})


export { addToCart, productInCart, getCartItems, removeCartItem }